var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
export var RecentItemsService = (function () {
    function RecentItemsService(storage) {
        this.storage = storage;
    }
    RecentItemsService.prototype.getLookingForType = function () {
        return this.storage.get('lookingForType').then(function (value) {
            return value;
        });
    };
    RecentItemsService.prototype.setLookingForType = function (value) {
        return this.storage.set('lookingForType', value);
    };
    RecentItemsService.prototype.getSellingType = function () {
        return this.storage.get('sellingType').then(function (value) {
            return value;
        });
    };
    RecentItemsService.prototype.setSellingType = function (value) {
        return this.storage.set('sellingType', value);
    };
    RecentItemsService.prototype.getExpires = function () {
        return this.storage.get('expires').then(function (value) {
            return value;
        });
    };
    RecentItemsService.prototype.setExpires = function (value) {
        return this.storage.set('expires', value);
    };
    RecentItemsService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [Storage])
    ], RecentItemsService);
    return RecentItemsService;
}());
